module.exports = __webpack_public_path__ + "img/sustainable_fishing.9c2e9f7e.svg";